import { Link, useLocation } from "react-router-dom";
import { GM_PANEL } from "@/constants/testIds";

const LINKS = [
  { to: "/ekonomika/gm", label: "Správa ekonomiky", icon: "fa-shield-halved", testId: GM_PANEL.economyLink },
  { to: "/sprava/galerie", label: "Galerie", icon: "fa-images", testId: GM_PANEL.galleryLink },
  { to: "/sprava/ucty", label: "Správa účtů", icon: "fa-user-lock", testId: GM_PANEL.accountsLink },
  { to: "/sprava/patche", label: "Patche", icon: "fa-file-arrow-up", testId: GM_PANEL.patchesLink },
];

// Right-hand navigation for GM-only tools, shown only to gmlevel=4 accounts
// across the whole account/economy area - same gating as the GM section.
export const GmPanel = () => {
  const location = useLocation();

  return (
    <nav
      data-testid={GM_PANEL.nav}
      className="h-fit rounded-xl border border-[#F0801F]/40 bg-[#17171b] p-5 shadow-[0_0_30px_rgba(240,128,31,0.12)] lg:sticky lg:top-28"
    >
      <div className="mb-4 flex items-center gap-2">
        <i className="fa-solid fa-shield-halved text-sm text-[#F0801F]" />
        <p className="font-display text-xs font-600 uppercase tracking-[0.3em] text-[#F0801F]">GM panel</p>
      </div>
      <ul className="space-y-1">
        {LINKS.map((link) => {
          const active = location.pathname === link.to;
          return (
            <li key={link.to}>
              <Link
                to={link.to}
                data-testid={link.testId}
                className={`flex items-center gap-2.5 rounded-md px-3 py-2.5 text-sm transition-colors ${
                  active
                    ? "bg-[#F0801F]/15 text-[#F0801F]"
                    : "text-white/70 hover:bg-white/[0.06] hover:text-white"
                }`}
              >
                <i className={`fa-solid ${link.icon} text-xs`} />
                {link.label}
              </Link>
            </li>
          );
        })}
      </ul>
      <p className="mt-4 border-t border-white/10 pt-4 text-xs text-white/40">
        Další nástroje pro správu světa se připravují.
      </p>
    </nav>
  );
};
